import { Star } from 'lucide-react';

import type { SiteContent } from '../../content/types';
import { formatDate } from '../../lib/utils';
import { Badge } from '../ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

interface ReviewListProps {
  content: SiteContent;
}

function Stars({ rating }: { rating: number }): JSX.Element {
  return (
    <div className="inline-flex items-center gap-1" aria-hidden="true">
      {Array.from({ length: 5 }).map((_, index) => (
        <Star key={index} className={`h-4 w-4 ${index < rating ? 'fill-amber-400 text-amber-400' : 'text-slate-300'}`} />
      ))}
    </div>
  );
}

export function ReviewList({ content }: ReviewListProps): JSX.Element {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      {content.reviewsSection.allReviews.map((review) => (
        <Card key={`${review.reviewer}-${review.date}-${review.text}`} className="h-full bg-white">
          <CardHeader className="space-y-2 pb-3">
            <div className="flex items-center justify-between gap-3">
              <CardTitle className="text-base">{review.reviewer}</CardTitle>
              <Badge variant="outline">{review.sentiment}</Badge>
            </div>
            <CardDescription>{formatDate(review.date, content.meta.locale)}</CardDescription>
            <Stars rating={review.rating} />
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm leading-relaxed text-[color:var(--color-muted)]">{review.text}</p>
            {review.ownerResponseSummary ? <p className="text-sm font-medium text-[color:var(--color-text)]">{review.ownerResponseSummary}</p> : null}
            <Badge>{review.sourceStatus}</Badge>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
